import * as React from 'react'

import { Box, Skeleton, Table } from '@factorialco/deprecated-design-system'

export const ReconciliationSkeleton: React.FC = () => {
  return (
    <Table.Row>
      <Table.Cell noBorder width={108} paddingX="s4">
        <Box style={{ paddingLeft: '20px' }}>
          <Skeleton width="s40" height="s8" isLoading />
        </Box>
      </Table.Cell>
      <Table.Cell noBorder paddingX="s4">
        <Box>
          <Skeleton width="s120" height="s8" isLoading />
        </Box>
      </Table.Cell>
      <Table.Cell noBorder paddingX="s4">
        <Box textAlign="right" justifyContent="flexEnd" flexDirection="row">
          <Skeleton width="s48" height="s8" isLoading />
        </Box>
      </Table.Cell>
      <Table.Cell noBorder paddingX="s0">
        <Box textAlign="right" justifyContent="flexEnd" flexDirection="row">
          <Skeleton width="s48" height="s8" isLoading />
        </Box>
      </Table.Cell>
      <Table.Cell noBorder paddingX="s0"></Table.Cell>
    </Table.Row>
  )
}
